import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  Tabs,
  Tab,
  Card,
  CardContent,
  IconButton,
} from "@mui/material";
import ProductCard from "./ProductCard"; // Ajusta la importación según tu estructura de carpetas
import ProductFormModal from "./ProductFormModal"; // Modal para agregar y editar productos
import { db } from "../firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { doc, updateDoc } from "firebase/firestore";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"; // Icono de "+" para agregar producto

function AdminDashboard() {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]); // Estado para productos filtrados
  const [openModal, setOpenModal] = useState(false); // Estado para controlar la visibilidad del modal
  const [selectedProduct, setSelectedProduct] = useState(null); // Estado para producto seleccionado (para editar)
  const [category, setCategory] = useState(0); // Estado para controlar la categoría seleccionada
  const [categories, setCategories] = useState([]); // Estado para almacenar las categorías disponibles

  // Función para obtener los productos desde Firestore
  const fetchProducts = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "bebidas"));
      const productsData = [];
      querySnapshot.forEach((doc) => {
        productsData.push({ ...doc.data(), id: doc.id }); // Obtener el ID del documento
      });
      setProducts(productsData);
      setFilteredProducts(productsData); // Inicialmente mostramos todos los productos

      // Extraer categorías únicas de los productos
      const uniqueCategories = [
        ...new Set(productsData.map((product) => product.categoria)),
      ];
      setCategories(uniqueCategories); // Actualizar el estado con las categorías únicas
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    fetchProducts(); // Obtener productos al montar el componente
  }, []);

  // Función para filtrar los productos por categoría
  const handleCategoryChange = (event, newValue) => {
    setCategory(newValue);
    if (newValue === 0) {
      setFilteredProducts(products); // Si la categoría es "Todos", mostrar todos los productos
    } else {
      setFilteredProducts(
        products.filter((product) => product.categoria === newValue)
      );
    }
  };

  // Función para abrir el modal para agregar un producto
  const handleOpenAddModal = () => {
    setSelectedProduct(null); // No se selecciona ningún producto, se va a agregar uno nuevo
    setOpenModal(true);
  };

  // Función para abrir el modal para editar un producto
  const handleOpenEditModal = (product) => {
    setSelectedProduct(product); // Establecer el producto seleccionado para editar
    setOpenModal(true);
  };

  // Función para cerrar el modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedProduct(null); // Limpiar el producto seleccionado al cerrar el modal
  };
  const handleFeaturedChange = async (productId, isFeatured) => {
    try {
      // Actualizar el estado en el cliente
      setProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.id === productId
            ? { ...product, destacado: isFeatured }
            : product
        )
      );

      // Obtener la referencia del documento en Firestore
      const productRef = doc(db, "bebidas", productId);

      // Actualizar el campo 'destacado' en Firestore
      await updateDoc(productRef, {
        destacado: isFeatured,
      });

      console.log(
        `Producto ${productId} actualizado en Firestore como ${
          isFeatured ? "destacado" : "no destacado"
        }`
      );
    } catch (error) {
      console.error("Error actualizando el producto:", error);
    }
  };

  const handleVisibilityChange = async (productId, newVisibilityStatus) => {
    try {
      // Actualiza el producto en el estado local
      setProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.id === productId
            ? { ...product, visible: newVisibilityStatus }
            : product
        )
      );

      // Actualiza la visibilidad en Firestore
      const productRef = doc(db, "bebidas", productId); // Asume que tienes una colección "products"
      await updateDoc(productRef, {
        visible: newVisibilityStatus,
      });

      console.log(
        `Visibilidad del producto ${productId} actualizada en Firebase`
      );
    } catch (error) {
      console.error("Error al actualizar la visibilidad en Firebase:", error);
    }
  };

  return (
    <Container className="admin-container" sx={{ marginBottom: 10 }}>
      <Typography variant="h4" gutterBottom color="#DEAC6F">
        Panel de Administración de Productos
      </Typography>

      {/* Pestañas para cambiar entre categorías */}
      <Tabs
        value={category}
        onChange={handleCategoryChange}
        indicatorColor="primary"
        textColor="primary"
        centered
        sx={{ marginTop: 3, background: "#DEAC6F" }}
      >
        <Tab label="Todos" value={0} />
        {categories.map((cat, index) => (
          <Tab key={index} label={cat} value={cat} />
        ))}
      </Tabs>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 2,
          marginTop: 2,
        }}
      >
        {/* Mostrar los productos */}
        {filteredProducts.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            handleEdit={() => handleOpenEditModal(product)}
            handleVisibilityChange={handleVisibilityChange}
            handleFeaturedChange={handleFeaturedChange} // Pasar la función aquí
          />
        ))}

        {/* Tarjeta para agregar producto */}
        <Card
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column", // Para colocar el ícono y texto en columna
            background: "none", // Gradiente de colores cálidos
            borderRadius: "12px", // Bordes redondeados
            padding: 4,
            cursor: "pointer",
            height: "auto", // Ajusta el tamaño de la tarjeta según sea necesario
          }}
          onClick={handleOpenAddModal}
        >
          <CardContent
            sx={{
              textAlign: "center",

              border: "3px solid #DEAC6F",
              height: "auto", // Ajusta el tamaño de la tarjeta según sea necesario
              borderRadius: "12px", // Bordes redondeados
              width: "100%",
            }}
          >
            <IconButton
              color="error"
              sx={{ fontSize: "70px", marginBottom: "10px" }}
            >
              <AddCircleOutlineIcon />
            </IconButton>
            <Typography
              variant="h6"
              sx={{ color: "white", fontWeight: "bold" }}
            >
              Agregar Producto
            </Typography>
          </CardContent>
        </Card>
      </Box>

      {/* Modal para agregar o editar productos */}
      <ProductFormModal
        open={openModal}
        handleClose={handleCloseModal}
        product={selectedProduct}
        fetchProducts={fetchProducts}
      />
    </Container>
  );
}

export default AdminDashboard;
